import Util from '../util/Util';
import FocusManagement from '../util/FocusManagement';

/**
 * Manages the various aria- properties for an expansion as well as any required class changes.
 *
 * @param args object with the properties {
 *   toggleSelector: The element that acts as a toggle
 *   targetSelector: The element being expanded
 *   parentSelector: (Default: 'body') A parent of both toggleSelector and targetSelector
 *   ariaHiddenSelector: (Default: none) If the targetSelector is aria-live, it can't also be aria-hidden (it doesn't
 *      announce showing/hiding itself as if it has changed).  So use this to select an element within the target to aria-hidden
 *
 *   onToggle: (Default: none) A function called on expand/contract
 * 
 *   expandedClass: (Default: 'expanded') Class for the targetSelector
 *   toggleExpandedClass: (Default: none) Class for the toggleSelector
 *   parentExpandedClass: (Default: none) Class for the parentSelector
 * }
 */
function init(args) {
  const parentSelector = (args.parentSelector || 'body');
  const expandedClass = (args.expandedClass || 'expanded');

  document.querySelectorAll(args.toggleSelector).forEach(toggle => {
    const parent = toggle.closest(parentSelector);
    if (!parent) { return; }
    
    const target = parent.querySelector(args.targetSelector);
    if (!target) { return; }

    const targetContent = (args.targetContentSelector && target.querySelector(args.targetContentSelector));

    // Set aria-controls
    if (!target.id) { target.id = Util.uniqueId(); }
    toggle.setAttribute('aria-controls', target.id);
    
    // Set aria-expanded
    if (!toggle.getAttribute('aria-expanded')) {
      toggle.setAttribute('aria-expanded', 'false');
    }
    
    const fnSetExpanded = (isExpanded) => {
      args.toggleExpandedClass && toggle.classList.toggle(args.toggleExpandedClass);
      args.parentExpandedClass && parent.classList.toggle(args.parentExpandedClass);
      
      args.onToggle && args.onToggle(isExpanded, target);
      toggle.setAttribute('aria-expanded', (isExpanded ? 'true' : 'false'));
      target.querySelector('ul').setAttribute('aria-hidden', (isExpanded ? 'false' : 'true'));

      FocusManagement.toggleFocusables(target, isExpanded);
    };
    
    const isExpanded = target.classList.contains(expandedClass);
    fnSetExpanded(isExpanded);
  
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const isExpanded = target.classList.toggle(expandedClass);
      fnSetExpanded(isExpanded);
    })
  });
}

export default { init };